import { useState } from 'react'

import CampaignBannerPc from '../../public/campaign_banner_default_pc.png'
import CampaignBannerSp from '../../public/campaign_banner_default_sp.png'

import { AwardContentReskilling } from '../AwardContentReskilling'

export const AwardContentSection = () => {
  const [showCampaignDetail, setShowCampaignDetail] = useState<boolean>(false)

  const toggleCampaignDetail = () => {
    setShowCampaignDetail(!showCampaignDetail)
  }

  const campaignDetails = {
    description: [
      '※ Wチャンスは体験レッスンへの予約申し込みがキャンペーン実施期間内であれば、実際にご参加される日がキャンペーン実施期間を過ぎていても対象となります。12月末までにご参加いただいた方が対象です。',
      '※ 過去参加者限定入会キャンペーンの方も対象となります。',
      '※ Wチャンスは11月14日〜11月20日にキャンペーンに申し込み、12月末までに無料体験レッスンに参加された方が抽選対象となります。',
      '※ プレゼントキャンペーンへの応募は、無料体験レッスン予約完了後に届くメールに記載のエントリーフォームからご応募ください。',
    ],
  }

  return (
    <div className="flex flex-col gap-6">
      <AwardContentReskilling />
      <div className="relative max-w-[750px] mx-auto mb-10">
        <img src={CampaignBannerSp.src} className="sp:block desktop:hidden" />
        <img src={CampaignBannerPc.src} className="sp:hidden desktop:block" />
        <div className="font-yu-gothic text-text-black text-base desktop:text-lg font-medium leading-[170%] tracking-[2.66px]">
          <div
            className="flex items-center mt-[10px] sp:ml-5 sp:whitespace-nowrap"
            onClick={toggleCampaignDetail}
          >
            <span>※</span>
            <span className="border-b border-text-black cursor-pointer">
              詳細は必ずこちらでご確認ください
            </span>
          </div>
          {showCampaignDetail && (
            <div className="mt-[10px] sp:mx-5">
              <ul>
                {campaignDetails.description.map((line, index) => (
                  <li
                    key={index}
                    className="list-none relative pl-[1.2em] mb-[10px] before:content-['※'] before:absolute before:left-0"
                  >
                    {line.replace(/^※\s*/, '')}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
